export var LegalEntity;
(function (LegalEntity) {
    LegalEntity["Business"] = "Business";
    LegalEntity["Partnership"] = "Partnership";
    // TODO: support in the future
    // Individual = 'Individual',
    // NonProfit = 'NonProfit',
    // PublicCompany = 'PublicCompany'
})(LegalEntity || (LegalEntity = {}));
//# sourceMappingURL=LegalEntity.js.map